// extracted by mini-css-extract-plugin
export default {"container":"style_container__sIZKJ","img":"style_img__tUNyb","title":"style_title__3CrPD","subtitle":"style_subtitle__K9Xvb"};